import { useCallback, useEffect, useState } from "react";
import { getMyEmployee } from "../api/employees";
import {
  PROFILE_COMPLETION_DEADLINE,
  PROFILE_UPDATED_EVENT,
  resolveProfileCompletionState,
} from "../utils/profileCompletionLock";

const UNLOCKED = {
  resolved: false,
  deadline: PROFILE_COMPLETION_DEADLINE,
  deadlinePassed: false,
  daysRemaining: 0,
  fieldsComplete: false,
  completionRequired: true,
  isLocked: false,
  declarationAcceptedAt: null,
};

export function useProfileCompletionLock() {
  const [state, setState] = useState(UNLOCKED);

  const applyFromEmployee = useCallback((employee) => {
    setState({
      resolved: true,
      ...resolveProfileCompletionState(employee),
    });
  }, []);

  useEffect(() => {
    let cancelled = false;

    getMyEmployee()
      .then((me) => {
        if (!cancelled) applyFromEmployee(me);
      })
      .catch(() => {
        if (!cancelled) {
          setState({ ...UNLOCKED, resolved: true, isLocked: false });
        }
      });

    function onUpdated(event) {
      if (event?.detail) applyFromEmployee(event.detail);
    }

    window.addEventListener(PROFILE_UPDATED_EVENT, onUpdated);
    return () => {
      cancelled = true;
      window.removeEventListener(PROFILE_UPDATED_EVENT, onUpdated);
    };
  }, [applyFromEmployee]);

  return state;
}
